import { pluralCategory } from '@/i18n/format.ts'
import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * `marketplace.report` em português do Brasil.
 *
 * As cinco categorias continuam sendo frases que uma pessoa diria sobre o que deu errado, e
 * não uma taxonomia de moderação — *Ele erra as coisas*, não *imprecisão*. As mesmas cinco
 * chaves do contrato aparecem de novo em `admin.reports` com outras palavras, de propósito
 * (PRD-27 D-9): lá quem lê está triando uma fila, aqui quem lê está contando o que aconteceu.
 * Uniformizar as duas seria desfazer a decisão.
 *
 * *Denunciar* em vez de *reportar*: é a palavra que produtos brasileiros usam para este
 * controle, e *reportar* neste sentido é decalque do inglês.
 */
export const report: Messages['marketplace']['report'] = {
  open: 'Denunciar este agente',
  title: (agentName) => `Denunciar ${agentName}`,
  lead: 'Isto vai para um administrador. A pessoa responsável pelo agente nunca fica sabendo quem denunciou.',
  categoryLabel: 'O que está errado',
  categories: {
    impersonation: 'Ele finge ser oficial ou ser alguém que não é',
    harmful: 'Ele disse algo prejudicial ou inseguro',
    wrong: 'Ele erra as coisas',
    inappropriate: 'Ele não é apropriado para o trabalho',
    other: 'Outra coisa'
  },
  noteLabel: 'Mais alguma coisa que um administrador deva saber — opcional',
  notePlaceholder: 'O que aconteceu e o que você esperava em vez disso.',
  /**
   * *caractere* / *caracteres*, com o número na frente para o contador continuar alinhado à
   * direita como em inglês. Zero cai na categoria `one` em português, então o contador
   * esgotado lê "0 caractere restante" — que é o certo, e é o motivo de a escolha passar por
   * `pluralCategory` e não por uma comparação com 1.
   */
  noteRemaining: (fmt, left) =>
    pluralCategory(fmt.locale, left) === 'one'
      ? `${fmt.formatCount(left)} caractere restante`
      : `${fmt.formatCount(left)} caracteres restantes`,
  submit: 'Enviar denúncia',
  submitting: 'Enviando…',
  cancel: 'Cancelar',
  close: 'Fechar',
  sent: 'Denunciado — um administrador vai analisar.',
  duplicate: 'Você já denunciou este agente. Um administrador ainda está com a denúncia aberta.',
  failed: 'Não foi possível enviar a denúncia. Tente de novo em instantes.'
}
